export default {
  title: 'Tableau de bord',
  welcome: 'Bon retour',
  overview: 'Aperçu',
  lastResources: 'Dernières ressources',
  stats: {
    totalResources: 'Total des Ressources',
    availableResources: 'Ressources Disponibles',
    categories: 'Catégories',
    recentResources: 'Ressources Récentes'
  },
  happeningToday: 'Voici ce qui se passe avec votre application aujourd\'hui.'
};
